import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals.js";
import "./styles/shared.scss";
import { AppConfigProvider } from "./context/AppConfigContext.jsx";
import { AppProvider } from "./context/appContext.jsx";
import { ErrorProvider } from "./context/errorContext.jsx";
import { SnackbarProvider } from "./context/SnackbarContext.jsx";
import { TranslationProvider } from "./context/TranslationContext.jsx";
import { BackendStatusProvider } from "./context/backendStatus/backendStatusContext.jsx";
import { AuthProvider } from "./context/AuthContext.jsx";
import { CognitoProvider } from "./context/CognitoContext.jsx";
import { AppWorkflowProvider } from "./context/AppWorkflowContext.jsx";
import { PollingManagerProvider } from "./context/PollingManagerContext.jsx";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
	<AppConfigProvider>
		<TranslationProvider>
			<SnackbarProvider>
				<ErrorProvider>
					<AppProvider>
						<BackendStatusProvider>
							<AuthProvider>
								<CognitoProvider>
									<AppWorkflowProvider>
										<PollingManagerProvider>
											<App />
										</PollingManagerProvider>
									</AppWorkflowProvider>
								</CognitoProvider>
							</AuthProvider>
						</BackendStatusProvider>
					</AppProvider>
				</ErrorProvider>
			</SnackbarProvider>
		</TranslationProvider>
	</AppConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
